module.exports = "<textarea placeholder=\"\"\r\n    id=\"editor\"\r\n    ng-value=\"$ctrl.contenido\"></textarea>\r\n";


//////////////////
// WEBPACK FOOTER
// ./src/fan/plantillas/components/editor/template.html
// module id = 248
// module chunks = 0